module.exports = __webpack_public_path__ + "static/media/righths.9b7c9863.png";